import React from 'react';
import { createRoot } from 'react-dom/client';
import { AppRegistry } from 'react-native';
import { configureSupabase } from '@restorant/core';
import { RestaurantApp } from '@restorant/ui';
import { LandingPage } from './site/LandingPage';

// Vite inlines VITE_* at build time. Missing values are fine: the app then runs
// entirely on device storage with no cloud sync.
configureSupabase({
  url: import.meta.env.VITE_SUPABASE_URL ?? '',
  publishableKey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ?? '',
});

/**
 * Two things share this build, and the path decides which one mounts.
 *
 *   /      the restaurant's public page — anyone, no account
 *   /app   the manager app — staff, behind a sign-in
 *
 * A router would be three dependencies and a provider for a decision made once,
 * before the first render, and never again: the two halves do not share
 * navigation, state or chrome, and moving between them is a page load either
 * way. `location.pathname` is the whole of it.
 */
const isApp = window.location.pathname.replace(/\/+$/, '') === '/app';

// The stylesheet in index.html pins html/body/#root to the viewport and turns
// off document scroll, because the app scrolls inside its own panes. A page of
// prose needs the opposite, so the shell only takes that shape when the app is
// the thing being mounted.
document.body.classList.add(isApp ? 'app-shell' : 'site-shell');

const container = document.getElementById('root');
if (!container) throw new Error('#root not found');

if (isApp) {
  // react-native-web needs the app registered so its own style reset is injected.
  AppRegistry.registerComponent('LuckFamily', () => RestaurantApp);
  createRoot(container).render(
    <React.StrictMode>
      {/* Fonts arrive via the stylesheet in index.html, so they are ready at mount. */}
      <RestaurantApp fontsReady />
    </React.StrictMode>,
  );
} else {
  document.title = 'The Luck Family Restaurant — Katargam, Surat';
  createRoot(container).render(
    <React.StrictMode>
      <LandingPage />
    </React.StrictMode>,
  );
}
